export default __webpack_public_path__ + "static/media/Christmas_09.67c20966.png";